// extracted by mini-css-extract-plugin
export default {"icon":"Actions_icon__c334S"};